var _path, _path2, _path3, _path4, _path5, _path6, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoNipa(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 50,
    viewBox: "0 0 78 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.46857 18.6703H9.54408C11.485 16.348 13.5197 15.5616 16.1795 15.5616C21.3483 15.5616 22.8925 18.8205 22.1447 23.5388L20.2641 35.4118H13.4469L14.9301 26.0489C15.221 24.214 16.0309 20.9926 12.6597 20.9926C9.88749 20.9926 8.77454 23.0528 8.3951 25.4503L6.81756 35.4118H0L3.04355 16.1985H9.86103L9.46857 18.6703Z",
    fill: "#004785"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.2002 8.82068C35.8679 10.9185 33.8722 12.6407 31.7746 12.6407C29.677 12.6407 28.226 10.9185 28.5586 8.82068C28.891 6.72296 30.8869 5 32.9846 5C35.0822 5 36.5321 6.72296 36.2002 8.82068Z",
    fill: "#D71920"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6167 35.4118H24.8L27.8435 16.1985H34.6602L31.6167 35.4118Z",
    fill: "#004785"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M41.1439 45H34.3268L38.8719 16.1985H45.6894L41.1439 45Z",
    fill: "#004785"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M74.6769 35.4118H67.8598L70.9029 16.1985H77.7204L74.6769 35.4118Z",
    fill: "#004785"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M65.7058 15.5202C62.8804 15.5202 60.124 16.6852 57.9642 18.5554C57.9642 18.5554 54.7088 21.1106 53.8588 25.5591C53.8453 25.6342 53.8296 25.7078 53.8177 25.7814C53.8059 25.8573 53.7982 25.9316 53.7882 26.0075C53.3145 28.2509 51.1552 30.0574 48.8847 30.0574C46.5384 30.0574 44.9164 28.1298 45.2881 25.7837C45.6596 23.4376 47.8921 21.5108 50.2384 21.5108C51.4687 21.5108 52.4974 22.0419 53.1451 22.885C54.1945 19.9733 56.225 18.1522 56.9712 17.5567C55.4623 16.2797 53.4666 15.5202 51.1851 15.5202C45.5511 15.5202 40.1892 20.148 39.2973 25.7814C38.4043 31.4155 42.2999 36.0433 47.935 36.0433C50.7596 36.0433 53.5161 34.8799 55.6758 33.0082C59.0462 30.3678 59.7901 25.9577 59.7901 25.9577C59.8005 25.8994 59.8131 25.8404 59.8223 25.7814C59.8319 25.7239 59.8373 25.6672 59.8457 25.6097C60.2976 23.3441 62.4714 21.5108 64.7588 21.5108C67.1047 21.5108 68.7271 23.4376 68.3553 25.7837C67.984 28.1298 65.7514 30.0574 63.4055 30.0574C62.1763 30.0574 61.1492 29.5262 60.5014 28.6854C60.1282 29.7585 59.0657 32.192 56.6777 34.013C58.1854 35.286 60.178 36.0433 62.455 36.0433C68.0893 36.0433 73.4508 31.4155 74.3431 25.7814C75.235 20.148 71.3399 15.5202 65.7058 15.5202Z",
    fill: "url(#paint0_linear_7202_53097)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7202_53097",
    x1: 1.8891,
    y1: 22.0465,
    x2: 76.7679,
    y2: 29.6813,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1517,
    stopColor: "#004785"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5169,
    stopColor: "#007DC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8652,
    stopColor: "#004785"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoNipa);
export default __webpack_public_path__ + "static/media/logo-nipa.5868a02e28e5cc9ac19edb7a6100b3f2.svg";
export { ForwardRef as ReactComponent };